import PageHero from '../modules/PageHero';
import { $ } from '@starberry/components';
// import MyAccountServices from 'core/services/store/myaccount/services';
// import * as MyAccountActions from 'core/services/store/myaccount/actions';

export default {
  $: 'Dashboard',
  title: 'My Property',
  content: [
    {
      $: 'Flex',
      children: [
        {
          $: 'SimpleTabs',
          provide: ['myaccount'],
          props: {
            tabs: [
              // { title: 'All Properties', content: { $: 'AllProperties' } },
              { title: 'Wishlist', id: 'wishlist', content: { $: 'Wishlist' } },
              { title: 'Saved Searches', id: 'saved-searches', content: { $: 'SavedSearches' } },
            ],
            width: '100%',
          },
        },
      ],
    },
  ],
};
